import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CommonService } from "src/app/services/common.service";
import { GlobalVariable } from "../../../app.component";
import { DataService, Response } from "./../../../dataService/data.service";

@Component({
  selector: "app-top-tile-two",
  templateUrl: "./top-tile-two.component.html",
  styleUrls: [
    "./top-tile-two.component.scss",
    "./../../overall-reviews/overall-reviews.component.scss",
  ],
})
export class TopTileTwoComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  appointmentDetail: any;
  isAppointment: boolean;
  mystoreDetail: any;
  deliveryType: any;
  outlet_id: string;
  @Input() mystoreData: any;
  @Input() isAnyAppointmentData: boolean;
  constructor(
    private router: Router,
    private HttpService: DataService,
    private commonService: CommonService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outlet_id = this.storage.get("outlet_id");
    console.log(this.router.url);
    if (this.router.url === "/dashboard/mystore") {
      this.getOrderDetails();
    } else if (this.router.url === "/dashboard/appointments") {
      this.getAppointmentDetails();
    }
  }

  getAppointmentDetails() {
    let res: Response;
    this.commonService.appointment_top_panel.subscribe((res) => {
      if (res) {
        if (res["code"] === 200) {
          this.isAppointment = true;
          this.appointmentDetail = res["data"];
          this.loading = false;
        }
      }
    });
  }

  getOrderDetails() {
    let res;
    // this.HttpService.getRequest({ customApiUrl: this.BASE_URL.VIEW_MYSTORE_TOP_TILE(this.outlet_id) })
    res = this.mystoreData;
    if (res) {
      if (res.code == 200) {
        this.isAppointment = false;
        this.mystoreDetail = res.data;
        console.log("this.mystoreDetail", this.mystoreDetail);
        // console.log(this.mystoreDetail);
        this.loading = false;
      }
    }
    this.HttpService.getRequest({
      customApiUrl: this.BASE_URL.MYSTORE_COMMON_SETTINGS(this.outlet_id),
    }).subscribe((data) => {
      let res = data;
      this.deliveryType = res.data["mystore_settings"]["delivery_type"];
      // console.log(this.deliveryType);
    });
  }

  redirectToAppointment() {
    this.router.navigate([`/appointments`]);
  }
  redirectToMystore() {
    this.router.navigate([`/mystore`]);
  }
}
